import { render, staticRenderFns } from "./InputSelectList.vue?vue&type=template&id=00b1ddf0"
import script from "./InputSelectList.vue?vue&type=script&lang=js"
export * from "./InputSelectList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports